
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningRainColour as ObiLightningRainColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-rain-colour.js';
 
 
 

 
 export const ObiLightningRainColour = createComponent({
   react: React,
   tagName: 'obi-lightning-rain-colour',
   elementClass: ObiLightningRainColourElement,
   events: {
     
   }
  });
 
 